import type { UpdateableAreaSubstrate } from '../../..'

/**
 *  Convert updateable price to areaSubstrate price
 */
export default function toSaveablePrice(areaSubstrate: UpdateableAreaSubstrate): {
  override_price: boolean
  price: number
  override_price_value: number
  default_price: number
} {
  return {
    override_price: areaSubstrate.price?.useCustom ?? false,
    override_price_value: areaSubstrate.price?.custom ?? 0,
    price: areaSubstrate.price?.default ?? 0,
    default_price: areaSubstrate.price?.default ?? 0
  }
}
